import React from "react";
import { Route } from "react-router-dom";

import PrivateRoutes from "../../components/Auth/PrivateRoutes";

//Import All Components
import * as Pages from "./Pages";

export const TCUserRoutes = (
  <Route element={<PrivateRoutes roleRequired={["TC_USER_ACCESS"]} />}>
    <Route path="/dashboard-tc" name="Home" element={<Pages.DashboardTC />} />
    <Route path="/patients" name="Patients" element={<Pages.PatientList />} />
    <Route path="/patient/" name="Patients" element={<Pages.PatientUpdate />} />
    <Route
      path="/user/profile"
      name="My Profile"
      element={<Pages.UpdateUserProfile />}
    />
    {/* Diagnosis */}
    <Route
      path="/add-diagnosis"
      name="Add-Diagnosis"
      element={<Pages.AddDiagnosis />}
    />
    <Route
      path="/patient-add"
      name="Patient Create"
      element={<Pages.PatientCreate />}
    />
    <Route
      path="/import-patients"
      name="Import Patients"
      element={<Pages.PatientImports />}
    />
    <Route
      path="/search-patient"
      name="Patient Search"
      element={<Pages.SearchPatientList />}
    />
    {/* Death Record Management */}
    <Route
      path="/patient/drecord"
      name="Add Death Record"
      element={<Pages.PatientDeathRecord />}
    />
    <Route
      path="/patient/drecord/view"
      name="View Patient Death Record"
      element={<Pages.ViewPatientDeathRecord />}
    />
    <Route
      path="/upcoming/appointments"
      name="Up Coming Appointments"
      element={<Pages.UpcomingList />}
    />
    <Route
      path="/appointmentlist"
      name="Appointment List"
      element={<Pages.AppointmentList />}
    />
    <Route
      path="/addappointment"
      name="Add New Appointment"
      element={<Pages.AddAppointment />}
    />
    <Route
      path="/editappointment"
      name="Edit Appointment"
      element={<Pages.UpdateAppointment />}
    />
    <Route
      path="/report"
      name="View Report"
      element={<Pages.PatientReport />}
    />
    <Route
      path="/listhrecord"
      name="List Health Record"
      element={<Pages.ListHealthRecord />}
    />
    {/* Pre Registration Patient */}
    <Route
      path="/pre/register/list"
      name="Pre Registration Patient"
      element={<Pages.PreRegistrationsList />}
    />
    <Route
      path="/pre/register/add"
      name="Pre Registration Add"
      element={<Pages.PreRegistrationAdd />}
    />
    <Route
      path="/pre/register/update"
      name="Pre Registration Update"
      element={<Pages.PreRegistrationUpdate />}
    />
    <Route
      path="/create-visit/"
      name="Create Visit"
      element={<Pages.CreateVisit />}
    />
    <Route
      path="/create-discharge/"
      name="Create Discharge"
      element={<Pages.CreateDischarge />}
    />
    <Route
      path="/view-discharge/"
      name="View Discharge"
      element={<Pages.ViewDischarge />}
    />
    <Route
      path="/visits/"
      name="Visits"
      element={<Pages.PatientVisitsList />}
    />
    <Route path="/visit/" name="View Visit" element={<Pages.PatientVisit />} />
    <Route path="/patient/emr/" name="EMR" element={<Pages.UpdateEmr />} />
    <Route
      path="/tclevelreport"
      name="TC Level Report"
      element={<Pages.PatientTCLevelReport />}
    />
    <Route
      path="/reports/generic/"
      name="Generic Report"
      element={<Pages.GenericReports />}
    />
    <Route
      path="/reports/agewise/"
      name="Age-wise Report"
      element={<Pages.AgeWiseReport />}
    />
    <Route
      path="/reports/bleedwise/"
      name="Bleed-wise Report"
      element={<Pages.BleedWiseReport />}
    />
    <Route
      path="/reports/jointswise/"
      name="Joints-wise Report"
      element={<Pages.JointsWiseReport />}
    />
    <Route
      path="/reports/severitywise/"
      name="Severity-wise Report"
      element={<Pages.SeverityWiseReport />}
    />
    <Route
      path="/dose-history-tc"
      name="Dosing History"
      element={<Pages.ListTCDosingHistory />}
    />
    <Route
      path="/dashboard-nc/"
      name="Dashboard Nodal Center"
      element={<Pages.DashboardNC />}
    />
    <Route
      path="/testimonials"
      name="Testimonials"
      element={<Pages.TestimonialList />}
    />
    <Route
      path="/testimonial/add"
      name="Add Testimonials"
      element={<Pages.AddTestimonial />}
    />

    <Route
      path="/products/"
      name="List Products"
      element={<Pages.ProductsList />}
    />

    <Route
      path="/pwtcinventory"
      name="Productwise TC Inventory"
      element={<Pages.ProductWiseTCInventory />}
    />
    <Route
      path="/tc-inventory"
      name="TC Inventory"
      element={<Pages.ListTCInventory />}
    />
    <Route
      path="/create-dose"
      name="Create Dose for Patient"
      element={<Pages.CreateDoseForPatient />}
    />
    <Route
      path="/view-dose"
      name="View Dose for Patient"
      element={<Pages.ViewDoseForPatient />}
    />
    <Route
      path="/dose/list"
      name="List Add Dose for Patient"
      element={<Pages.ViewDoseTable />}
    />
    <Route
      path="/list-purchase-tc"
      name="Inventory Add"
      element={<Pages.ListPurchaseTC />}
    />
    <Route
      path="/add-purchase-tc"
      name="Add Purchase Child"
      element={<Pages.AddPurchaseTC />}
    />
    <Route
      path="/tc-settlement-history"
      name="ListTCSettlementHistory"
      element={<Pages.TCSettlementHistory />}
    />
    <Route
      path="/purchase-request-add"
      name="Create Request"
      element={<Pages.CreateRequest />}
    />
    <Route
      path="/purchase-requests"
      name="List Request"
      element={<Pages.PurchaseRequests />}
    />
    <Route
      path="/suppliers"
      name="List Suppliers"
      element={<Pages.Suppliers />}
    />
    {/* Global Patient Search */}
    <Route
      path="/global/search"
      name="Patient Search"
      element={<Pages.GlobalSearch />}
    />
    {/* Select Export to Excel */}
    <Route
      path="/export/toexcel"
      name="Patient Search"
      element={<Pages.SelectExportToExcel />}
    />
    {/* Notification Route */}
    <Route
      path="/notifications"
      name="Notifications"
      element={<Pages.Notifications />}
    />
    {/* Doctors of TC */}
    <Route path="/doctors" name="Doctors" element={<Pages.DoctorsList />} />
    {/* Add Doctor */}
    <Route
      path="/users/add-doctor"
      name="Add Doctor"
      element={<Pages.CreateDoctor />}
    />
    {/* Update Doctor */}
    <Route
      path="/doctor/update"
      name="Update Doctor"
      element={<Pages.UpdateDoctor />}
    />
    {/* ReAllocation Register */}
    <Route
      path="/rellocation/list"
      name="Local ReAllocation"
      element={<Pages.ListReAllocationHistory />}
    />
    {/* TC Profile View */}
    <Route
      path="/tc-profile"
      name="My TC Profile"
      element={<Pages.MyTCProfileView />}
    />
    {/* List Local Purchases */}
    <Route
      path="/list-lpo"
      name="Manage LPO"
      element={<Pages.ListTCLocalPurchases />}
    />
    {/* Add Local Purchases */}
    <Route
      path="/add-lpo"
      name="Add LPO"
      element={<Pages.AddLocalPurchaseOrder />}
    />
    {/* Update Local Purchases */}
    <Route
      path="/update-lpo"
      name="Update LPO"
      element={<Pages.UpdateLocalPurchaseOrder />}
    />
    {/* Add Product Route */}
    <Route
      path="/addproduct"
      name="Add Product"
      element={<Pages.AddProduct />}
    />
    {/* Update Product */}
    <Route
      path="/updateproduct"
      name="Update Products"
      element={<Pages.UpdateProduct />}
    />
    {/* Patient timeline */}
    <Route
      path="/patient-timeline"
      name="Patient Timeline"
      element={<Pages.PatientTimeline />}
    />
    {/* Find Product Route */}
    <Route
      path="/find-product"
      name="Find Product"
      element={<Pages.FindProductInventory />}
    />
    {/* Product request outgoing */}
    <Route
      path="/outgoing-requests"
      name="Product Request outgoing"
      element={<Pages.ListProductRequestOutgoing />}
    />
    {/* Product request incoming */}
    <Route
      path="/incoming-requests"
      name="Product Request incoming"
      element={<Pages.ListProductRequestIncoming />}
    />
  </Route>
);
